import React, { useState } from 'react';
import { Clock, MessageCircle, Phone, Mail, Smartphone, Star, CheckCircle, Calendar, Lock, Headset } from 'lucide-react';
export function LegalHelpBox() {
  const [inquiry, setInquiry] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    if (inquiry.trim()) {
      console.log('Submitting inquiry:', {
        inquiry
      });
      setInquiry('');
    }
  };
  return <div className="bg-white border border-borderColor rounded-xl p-8 lg:p-10 shadow-sm" data-id="element-225">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6" data-id="element-226">
        <div className="p-2.5 bg-aliceBlue rounded-lg" data-id="element-227">
          <Headset className="w-5 h-5 text-violetBlue" data-id="element-228" />
        </div>
        <div data-id="element-229">
          <h3 className="text-xl font-semibold text-primary" data-id="element-230">
            24/7 Legal Help
          </h3>
          <p className="text-sm text-secondary" data-id="element-231">Connect with legal experts</p>
        </div>
      </div>

      {/* Two-column layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-232">
        {/* Left Column - Content */}
        <div className="space-y-6" data-id="element-233">
          {/* Expert Avatars */}
          <div className="flex items-center gap-3" data-id="element-234">
            <div className="flex -space-x-2" data-id="element-235">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" alt="Legal expert" className="w-9 h-9 rounded-full border-2 border-white object-cover shadow-sm" data-id="element-236" />
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=faces" alt="Legal expert" className="w-9 h-9 rounded-full border-2 border-white object-cover shadow-sm" data-id="element-237" />
              <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop&crop=faces" alt="Legal expert" className="w-9 h-9 rounded-full border-2 border-white object-cover shadow-sm" data-id="element-238" />
            </div>
            <span className="text-sm text-secondary font-medium" data-id="element-239">
              Trusted legal professionals
            </span>
          </div>

          {/* Benefits List */}
          <div className="space-y-4" data-id="element-240">
            <div className="flex items-start gap-3" data-id="element-241">
              <div className="mt-0.5" data-id="element-242">
                <Clock className="w-4 h-4 text-violetBlue" data-id="element-243" />
              </div>
              <span className="text-sm text-secondary" data-id="element-244">
                Available 24/7, 7 days a week
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-245">
              <div className="mt-0.5" data-id="element-246">
                <Calendar className="w-4 h-4 text-violetBlue" data-id="element-247" />
              </div>
              <span className="text-sm text-secondary" data-id="element-248">
                Book a time that works for you
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-249">
              <div className="mt-0.5" data-id="element-250">
                <CheckCircle className="w-4 h-4 text-violetBlue" data-id="element-251" />
              </div>
              <span className="text-sm text-secondary" data-id="element-252">
                Get matched to the right expert
              </span>
            </div>
          </div>

          {/* Short Explanation */}
          <p className="text-sm text-secondary leading-relaxed" data-id="element-253">
            Send your question, pick a preferred time, and a legal expert will
            follow up.
          </p>
        </div>

        {/* Right Column - Action Panel */}
        <div className="bg-aliceBlue border border-borderColor rounded-xl p-6 space-y-5" data-id="element-254">
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-255">
            {/* Step 1: Question */}
            <div data-id="element-256">
              <label htmlFor="inquiry" className="block text-sm font-medium text-primary mb-2" data-id="element-257">
                Your Legal Question
              </label>
              <textarea id="inquiry" value={inquiry} onChange={e => setInquiry(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} placeholder="Describe your legal question or concern..." rows={isFocused ? 5 : 3} className="w-full bg-white border border-borderColor rounded-lg px-4 py-3 text-sm text-primary placeholder-disabled focus:outline-none focus:border-violetBlue focus:ring-2 focus:ring-violetBlue/20 resize-none transition-all duration-200" required data-id="element-258" />
            </div>

            {/* CTA Button */}
            <button type="submit" className="w-full bg-white border-2 border-violetBlue text-violetBlue hover:bg-aliceBlue font-medium py-3 px-4 rounded-lg transition-colors duration-200" data-id="element-259">
              Request a Call
            </button>

            {/* Response Time */}

            {/* Privacy Note */}
          </form>
        </div>
      </div>
    </div>;
}